import styled from "styled-components"
import Div from "../../components/div/div.component"

export const BlogPostContainer = styled(Div)`
  display: grid;
  grid-template-columns: 1fr min(1340px, calc(100% - 100px)) 1fr;
  grid-column-gap: 50px;
  & > * {
    grid-column: 2;
  }
  .full-bleed {
    width: 100%;
    grid-column: 1 / -1;
  }
  @media screen and (max-width: 1000px) {
    grid-template-columns: 1fr calc(100% - 40px) 1fr;
    grid-column-gap: 20px;
  }
`

BlogPostContainer.displayName = "BlogPostContainer"
